import {JSX} from 'react';
import IconDiamond from "@/assets/icons/diamond-filled.svg?react";
import {useTranslation} from "react-i18next";

interface Props {
    description?: string
    children?: JSX.Element
    onClick?: () => void
}

const BuyPremiumBanner = ({description = "buy", children, onClick}: Props) => {
    const {t} = useTranslation();

    return (
        <div className="relative flex items-center justify-between bg-yellow-linear rounded-xl px-3 pt-2.5 pb-3 cursor-pointer transition click-button"
             onClick={onClick}>
            <div className="flex items-center justify-start gap-2">
                <IconDiamond width="24" height="24" className="text-black"/>
                <div>
                    <h1 className="text-black uppercase leading-5 font-bold text-base self-stretch">Premium</h1>
                    <p className="text-black text-xs font-medium leading-normal self-stretch">{t(description)}</p>
                </div>
            </div>
            {children}
            <img
                src="images/patterns/buy-premium.webp"
                width="86"
                height="70"
                className="absolute right-4 bottom-0 z-0"
                alt=""
            />
        </div>
    );
};

export default BuyPremiumBanner;